import { api } from './client';

export interface Invitation {
  id:        string;
  email:     string;
  role:      'EDITOR' | 'VIEWER';
  status:    'PENDING' | 'ACCEPTED' | 'REVOKED' | 'EXPIRED';
  createdAt: string;
  expiresAt: string;
  /** Sent from a placeholder's row: accepting merges it (ADR-0021). */
  placeholderUserId: string | null;
}

export interface InvitationPreview {
  tripName:        string;
  tripDestination: string;
  tripDates:       string;
  inviterName:     string;
  role:            'EDITOR' | 'VIEWER';
  expiresAt:       string;
}

export const invitationsApi = {
  list: (tripId: string) =>
    api.get<Invitation[]>(`/trips/${tripId}/invitations`).then(r => r.data),

  create: (tripId: string, email: string, role: 'VIEWER' | 'EDITOR', locale?: string) =>
    api.post<Invitation>(`/trips/${tripId}/invitations`, { email, role, locale }).then(r => r.data),

  revoke: (tripId: string, invitationId: string) =>
    api.delete(`/trips/${tripId}/invitations/${invitationId}`),

  preview: (token: string) =>
    api.get<InvitationPreview>(`/invitations/${encodeURIComponent(token)}`).then(r => r.data),

  accept: (token: string) =>
    api.post<{ tripId: string }>('/invitations/accept', { token }).then(r => r.data),

  /** ADR-0033: the code an agency hands its client; works only for the invited email. */
  redeemCode: (code: string) =>
    api.post<{ tripId: string }>('/invitations/redeem-code', { code }).then(r => r.data),
};
